'use strict';

(function (global) {

  // Способы масштабирования области предпросмотра
  const PREVIEW_SCALE = {
    FIT_HEIGHT: 'h',
    FIT_WIDTH: 'w',
    FIT_WINDOW: 'a',
  };

  const PREVIEW_SCALE_LOCALIZATION = {
    FIT_HEIGHT: L('FIT_HEIGHT'),
    FIT_WIDTH: L('FIT_WIDTH'),
    FIT_WINDOW: L('FIT_WINDOW'),
  };

  // Идентификаторы для хранения приватных свойств с jQuery-объектами тулбара
  const toolbarPrivatePropertyKey = Symbol('toolbar');
  const toolbarDataPrivatePropertyKey = Symbol('toolbarData');
  const toolbarControlsPrivatePropertyKey = Symbol('toolbarControls');

  /**
   * Тулбар предпросмотра.
   *
   * @hideconstructor
   * @since 5.7.0
   */
  class Toolbar {

    init(){
      this[toolbarPrivatePropertyKey] = $('#preview-panel');

      // Модель тулбара предпросмотра
      this[toolbarDataPrivatePropertyKey] = {
        paginationButtons: new Map([
          ['previousPage', {
            cssClass: '.preview-panel__control-arrow_left',
            action: () => window.Core.preview.actions.goToPreviousPage(),
          }],
          ['nextPage', {
            cssClass: '.preview-panel__control-arrow_right',
            action: () => window.Core.preview.actions.goToNextPage(),
          }],
        ]),
        commonButtons: new Map([
          ['printFromPreview', {
            cssClass: '.print-from-preview',
            action: () => window.Core.preview.actions.printDocFromPreview(),
          }],
          ['changeWindowMode', {
            cssClass: '.change-window-mode',
            action: () => window.Core.preview.actions.toggleFullscreen(),
          }],
        ]),
        fitToButtons: new Map([
          ['fitToHeight', {
            cssClass: '.fit-to-height',
            scale: PREVIEW_SCALE.FIT_HEIGHT,
          }],
          ['fitToWidth', {
            cssClass: '.fit-to-width',
            scale: PREVIEW_SCALE.FIT_WIDTH,
          }],
          ['fitToWindow', {
            cssClass: '.fit-to-window',
            scale: PREVIEW_SCALE.FIT_WINDOW,
          }],
        ]),
        rotateButtons: new Map([
          ['rotateCW', {
            cssClass: '.rotate-CW',
            action: () => window.Core.preview.actions.rotateCW(),
          }],
          ['rotateCCW', {
            cssClass: '.rotate-CCW',
            action: () => window.Core.preview.actions.rotateCCW(),
          }],
        ]),
        wordButtons: new Map([
          ['enableChangeTrack', {
            cssClass: '.enable-change-track',
            action: () => window.Core.preview.actions.enableTrackChanges(),
            reverseAction: () => window.Core.preview.actions.disableTrackChanges(),
          }],
          ['enableComments', {
            cssClass: '.enable-comments',
            action: () => window.Core.preview.actions.enableComments(),
            reverseAction: () => window.Core.preview.actions.disableComments(),
          }],
        ]),
      };

      this[toolbarControlsPrivatePropertyKey] = this._prepareControls();

      this._initButtons();
      this.initScaleInputValues();
    }

    /**
     * Инициализация значений масштаба для документа.
     *
     * @method initScaleInputValues
     * @inner
     */
    initScaleInputValues() {
      // Скорректировать значения масштаба для документов
      const jScaleInput = $('#scaleinp');
      const scaleRequisiteInstance = jScaleInput.data('DropDownListInstance');
      if (!!scaleRequisiteInstance) {
        let scaleDropDownItems = scaleRequisiteInstance['clearDropDownListItems'];
        if (!!scaleDropDownItems) {
          scaleDropDownItems.apply(scaleRequisiteInstance);
        }
      }

      // Добавить значения
      let values;
      if (Core.preview.document.dataType.isText) {
        values = [
          [
            PREVIEW_SCALE.FIT_WIDTH,
            PREVIEW_SCALE_LOCALIZATION.FIT_WIDTH,
            PREVIEW_SCALE_LOCALIZATION.FIT_WIDTH,
            false,
          ],
        ];
      } else {
        values = [
          [
            PREVIEW_SCALE.FIT_WIDTH,
            PREVIEW_SCALE_LOCALIZATION.FIT_WIDTH,
            PREVIEW_SCALE_LOCALIZATION.FIT_WIDTH,
            false,
          ],
          [
            PREVIEW_SCALE.FIT_HEIGHT,
            PREVIEW_SCALE_LOCALIZATION.FIT_HEIGHT,
            PREVIEW_SCALE_LOCALIZATION.FIT_HEIGHT,
            false,
          ],
          [
            PREVIEW_SCALE.FIT_WINDOW,
            PREVIEW_SCALE_LOCALIZATION.FIT_WINDOW,
            PREVIEW_SCALE_LOCALIZATION.FIT_WINDOW,
            false,
          ],
        ];
      }
      for (let scale = 20; scale <= 200; scale += 20) {
        values.push(
          [scale.toString(), `${scale}%`, `${scale}%`, false ],
        );
      }
      values.forEach(value => {
        if (!!scaleRequisiteInstance) {
          let scaleDropDownItems = scaleRequisiteInstance['addDropDownListItem'];
          if (!!scaleDropDownItems) {
            scaleDropDownItems.apply(scaleRequisiteInstance, [value,]);
          }
        }        
      });
    }

    /**
     * Показывает или скрывает паджинацию; заполняет количество страниц документа.
     *
     * @param {number} pageCount
     */
    updatePaginator(pageCount) {
      const { pagination } = this.controls;
      if (pageCount <= 1) {
        pagination.hide();
      } else {
        pagination.updatePageCount(pageCount);
        pagination.show();
      }
    }

    /**
     * Tулбар предпросмотра.
     *
     * @private
     * @property _jToolbar
     * @return {Object} jQuery-объект тулбара предпросмотра.
     */
    get _jToolbar() {
      return this[toolbarPrivatePropertyKey];
    }

    /**
     * Модель тулбара предпросмотра.
     *
     * @private
     * @property _data
     * @return {Object} моджель тулбара предпросмотра.
     */
    get _data() {
      return this[toolbarDataPrivatePropertyKey];
    }

    /**
     * Контролы предпросмотра.
     *
     * @property controls
     * @return {Object} Список контролов тулбара предпросмотра.
     */
    get controls() {
      return this[toolbarControlsPrivatePropertyKey];
    }

    /**
     * Создать список контролов тулбара предпросмотра
     *
     * @method _initControls
     * @private
     * @return {Object} список контролов тулбара предпросмотра.
     */
    _prepareControls() {

      /**
       * Получить селекторы контрола из модели тулбара
       *
       * @function getButtonSelectorHelper
       * @inner
       * @property {object} buttonGroupData Модель данных группы кнопок тулбара
       */
      const getControlSelectorHelper = (buttonGroupData) => {
        return Array.from(buttonGroupData, (
          [, buttonData]) => buttonData.cssClass
        );
      };

      // Список селекторов контролов тулбара
      let controlSelectors = {
        scale: ['#scale'],
        fitToButtons: getControlSelectorHelper(this._data.fitToButtons),
        rotateButtons: getControlSelectorHelper(this._data.rotateButtons),
        wordButtons: getControlSelectorHelper(this._data.wordButtons),
      };

      let controls = {};
      Object.keys(controlSelectors).map((controlName) => {
        controls[controlName] = new window.Core.preview.toolbar.ToolbarControl(controlSelectors[controlName]);
      });
      // Контрол пагинации создаётся из отдельного класса, так как у него есть свой метод updatePageCount
      controls.pagination = new window.Core.preview.toolbar.PaginationToolbarControl(['#paginator']);

      return controls;
    }

    /**
     * Инициализировать кнопки тулбара предпросмотра
     *
     * @method _initButtons
     * @private
     */
    _initButtons() {
      this.buttons = {};

      this._bindContextMenuButton();
      this._bindPaginationControl();
      for (let [buttonName, buttonData] of this._data.fitToButtons ) {
        this.buttons[buttonName] = new window.Core.preview.toolbar.FitToToolbarButton(
          buttonData.cssClass,
          buttonData.scale
        );
      }
      for (let [buttonName, buttonData] of this._data.rotateButtons ) {
        this.buttons[buttonName] = new window.Core.preview.toolbar.BaseToolbarButton(
          buttonData.cssClass,
          buttonData.action
        );
      }
      for (let [buttonName, buttonData] of this._data.wordButtons ) {
        this.buttons[buttonName] = new window.Core.preview.toolbar.SelectableToolbarButton(
          buttonData.cssClass,
          buttonData.action,
          buttonData.reverseAction
        );
      }
      for (let [buttonName, buttonData] of this._data.commonButtons ) {
        this.buttons[buttonName] = new window.Core.preview.toolbar.BaseToolbarButton(
          buttonData.cssClass,
          buttonData.action
        );
      }
    }

    /**
     * Привязать (bind) нажатие кнопки вызова контектсного меню к соответсвующей фукциональности.
     * Эта кнопка доступна только в полноэкранном режиме.
     *
     * @method _bindContextMenuButton
     * @private
     */
    _bindContextMenuButton() {
      const jContextMenuButton = this._jToolbar.find('.document-context-menu');
      if (!jContextMenuButton.length) {
        return;
      }

      jContextMenuButton
        .attr('id', WA.CR.ID)
        .attr('kind', 'edoc')
        .addClass('cannot_delete');

      jContextMenuButton.on('click', () => {
        // Добавляем атрибуты, необходимые для работы contextmenu
        const jButtonsPanel = jContextMenuButton.closest('.preview-panel');
        const contextmenuOffset = {
          left: jContextMenuButton.offset().left,
          top: jButtonsPanel.offset().top + jButtonsPanel.outerHeight(),
        };

        window.Core.contextmenu.show(jContextMenuButton, {}, contextmenuOffset, false);
        return false;
      });
    }

    /**
     * Привязать (bind) действия над контролом пагинации к соответсвующей фукциональности.
     *
     * @method _bindPaginationControl
     * @private
     */
    _bindPaginationControl() {
      /**
       * Обёртка над функцией перехода на новую страницу документа.
       *
       * @function setJumpToPageWrapper
       * @inner
       * @param {object} domButton DOM-элемент кнопки тулбара предпросмотра.
       */
      const setJumpToPageWrapper = (domButton) => {
        const jButton = $(domButton);
        const newPageNumber = Number(jButton.val());
        window.Core.preview.actions.jumpToPage(newPageNumber);
      };

      // Обработка событий поля ввода страницы документа
      const jPageNumberField = this._jToolbar.find('.page-number-field');
      jPageNumberField.on('keypress', event => {
        if (event.which === 13) {
          setJumpToPageWrapper(event.target);
          event.preventDefault();
        }

        if (String.fromCharCode(event.which).match(/[^0-9]/g)) {
          event.preventDefault();
        }
      }).on('blur', event => {
        setJumpToPageWrapper(event.target);
      });

      for (let [buttonName, buttonData] of this._data.paginationButtons ) {
        this.buttons[buttonName] = new window.Core.preview.toolbar.BaseToolbarButton(
          buttonData.cssClass,
          buttonData.action
        );
      }
    }
  }

  global.toolbar = new Toolbar();

})(window.Core.preview);